import React, { useState } from 'react';
import { Icon } from '../../Icon';
import { parseBrazilianNumber } from '../../../utils/formatUtils';
import { FormField, ResultCard, EducationalBlock } from '../finance/shared';

const WaterIntakeCalculator = ({ onResultChange }: { onResultChange: (data: { label: string, value: string }[]) => void }) => {
  const [weight, setWeight] = useState('');
  const [activity, setActivity] = useState('moderate');
  const [climate, setClimate] = useState('normal');
  const [resultState, setResultState] = useState<any>(null);

  const calculate = () => {
    const w = parseFloat(parseBrazilianNumber(weight)) || 0;
    if (w <= 0) return;

    let baseIntake = w * 35;
    const activityAdjustments = { sedentary: 0, light: 500, moderate: 1000, active: 1500, very_active: 2000 };
    const climateAdjustments = { cold: -500, normal: 0, hot: 1000 };

    const totalIntake = baseIntake + (activityAdjustments[activity as keyof typeof activityAdjustments] || 1000) + (climateAdjustments[climate as keyof typeof climateAdjustments] || 0);
    const intakeInLiters = totalIntake / 1000;
    const intakeInGlasses = Math.round(totalIntake / 250);

    setResultState({ intakeInLiters, intakeInGlasses });
    onResultChange([
      { label: 'Peso', value: `${w} kg` },
      { label: 'Ingestão Diária', value: `${intakeInLiters.toFixed(1)} L` },
      { label: 'Copos (250ml)', value: intakeInGlasses.toString() }
    ]);
  };

  return (
    <div className="space-y-8">
      <div className="bg-theme-result p-6 rounded-2xl border border-theme-border">
        <h2 className="text-xl font-bold text-theme-text mb-3">Calculadora de Água</h2>
        <p className="text-theme-muted">Mantenha sua hidratação em dia calculando suas necessidades diárias.</p>
      </div>

      <div className="bg-theme-result p-8 rounded-3xl shadow-lg border border-theme-border">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <FormField label="Peso (kg)" placeholder="Ex: 70" value={weight} onChange={setWeight} required isNumeric type="text" />
          <FormField label="Atividade" value={activity} onChange={setActivity} type="select" options={[
            { value: 'sedentary', label: 'Sedentário' }, { value: 'moderate', label: 'Moderado' }, { value: 'active', label: 'Ativo' }
          ]} />
          <FormField label="Clima" value={climate} onChange={setClimate} type="select" options={[
            { value: 'cold', label: 'Frio' }, { value: 'normal', label: 'Normal' }, { value: 'hot', label: 'Quente' }
          ]} />
        </div>
        <div className="flex justify-center mt-8">
          <button onClick={calculate} className="px-12 py-4 bg-accent-gradient text-white rounded-xl font-bold hover:shadow-accent-hover transition-all flex items-center gap-2">
            <Icon name="play" className="w-5 h-5" />
            Calcular Água
          </button>
        </div>
      </div>

      {resultState && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <ResultCard title="Consumo Diário" value={`${resultState.intakeInLiters.toFixed(1)} L`} color="blue" description={`${resultState.intakeInGlasses} copos de 250ml`} />
          <ResultCard title="Status" value="Excelente" color="emerald" description="Hidratação ideal para seu perfil" />
        </div>
      )}
    </div>
  );
};

export default WaterIntakeCalculator;
